import { authHeader, handleResponse } from './helpers';

const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

// -----------------------------
// Utility helpers (URLs)
// -----------------------------

export const getTenantLogoUrl = (tenantId) =>
  `${API_BASE_URL}/tenants/tenants/${tenantId}/logo/`;

export const getTenantBackgroundUrl = (tenantId) =>
  `${API_BASE_URL}/tenants/tenants/${tenantId}/background/`;

// Tenants - all info
export const fetchTenantInfoAdmin = async () => {
  const url = `${API_BASE_URL}/tenants/tenants/me/`;
  const res = await fetch(url, { headers: { ...authHeader() } });
  return handleResponse(res, 'Failed to fetch tenant info');
};

// -----------------------------
// Tenants - public info
// -----------------------------

/**
 * Fetch public info about a tenant.
 * If `slug` is provided → GET /tenants/tenants/public/?slug={slug}
 * If no slug → backend infers tenant from authenticated user.
 */
export const fetchPublicTenantInfo = async (slug = null) => {
  const url = new URL(`${API_BASE_URL}/tenants/tenants/public/`);
  const headers = {};

  if (slug) {
    url.searchParams.append('slug', slug);
  } else {
    Object.assign(headers, authHeader());
  }

  const res = await fetch(url, { headers });
  return handleResponse(res, 'Failed to fetch tenant public info');
};

// -----------------------------
// Tenants - public update (JSON or multipart)
// -----------------------------

/**
 * Generic JSON-based PATCH for any fields.
 * PATCH /tenants/tenants/{id}/update_public/
 */
export const updateTenantInfo = async (tenantId, data = {}) => {
  const url = `${API_BASE_URL}/tenants/tenants/${tenantId}/update_public/`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Failed to update tenant info');
};

/**
 * Generic multipart/form-data PATCH.
 * Accepts arbitrary key-value pairs (fields and File objects).
 * PATCH /tenants/tenants/{id}/update_public/
 */
export const updateTenantInfoWithFiles = async (tenantId, data = {}) => {
  const url = `${API_BASE_URL}/tenants/tenants/${tenantId}/update_public/`;
  const form = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value);
  });

  const res = await fetch(url, {
    method: 'PATCH',
    headers: { ...authHeader() }, // let browser set boundary
    body: form,
  });
  return handleResponse(res, 'Failed to update tenant info (multipart)');
};

export const fetchMyTenantStats = async (days = 30) => {
  const url = new URL(`${API_BASE_URL}/tenants/tenants/my-stats/`);
  url.searchParams.append('days', String(days));

  const res = await fetch(url, { headers: { ...authHeader() } });
  return handleResponse(res, 'Failed to fetch tenant stats');
};